import type React from 'react';
import { useCallback } from 'react';

import { Chip, Grid } from '@mui/material';

export interface ParticipantGridItem {
  participantName?: string;
  person?: { standardGivenName?: string; standardFamilyName?: string };
  participantId: string;
}

export interface ParticipantsNamesGridProps {
  participants: ParticipantGridItem[];
  nameStyle?: 'participant' | 'person-reversed-uppercase-surname';
  onDelete?: (item: ParticipantGridItem) => void;
}

const ParticipantsNamesGrid: React.FC<React.PropsWithChildren<ParticipantsNamesGridProps>> = ({
  participants,
  onDelete,
  nameStyle = 'participant',
}) => {
  const resolveParticipantName = useCallback(
    ({ person, participantName }: ParticipantGridItem) => {
      if (nameStyle === 'participant' || !person) return participantName;
      return `${(person.standardFamilyName ?? '').toUpperCase()}, ${person.standardGivenName ?? ''}`.trim();
    },
    [nameStyle],
  );

  return (
    !!participants?.length && (
      <Grid container>
        {participants?.map((p) => (
          <Grid key={p.participantId} item id={`name-grid-item-${p.participantId}`} margin={1}>
            <Chip
              label={resolveParticipantName(p)}
              size="medium"
              sx={{ borderRadius: 0 }}
              onDelete={onDelete && (() => onDelete(p))}
            />
          </Grid>
        ))}
      </Grid>
    )
  );
};

export default ParticipantsNamesGrid;
